import { gql } from '@apollo/client';
import {
  CampaignContainerFragment,
  ColorFragment,
  PageContentFragment,
  ProductHeroFragment,
  ResponsiveImageFragment,
  SeoMetaTagsFragment,
} from './fragments';

export const ProductPageFragment = gql`
  ${SeoMetaTagsFragment}
  ${ProductHeroFragment}
  ${PageContentFragment}
  fragment ProductPageFragment on ProductPageRecord {
    __typename
    id
    slug
    name
    seo: _seoMetaTags {
      ...SeoMetaTagsFragment
    }
    hero {
      ...ProductHeroFragment
    }
    content {
      id
      anchor
      content {
        ...PageContentFragment
      }
    }
    parentPage: parentSolution {
      id
      slug
    }
  }
`;

export const FinancingPageFragment = gql`
  ${SeoMetaTagsFragment}
  ${ProductHeroFragment}
  ${PageContentFragment}
  fragment FinancingPageFragment on FinancingPageRecord {
    id
    slug
    name
    seo: _seoMetaTags {
      ...SeoMetaTagsFragment
    }
    __typename
    hero {
      ...ProductHeroFragment
    }
    content {
      id
      anchor
      content {
        ...PageContentFragment
      }
    }
    parentPage: parentSolution {
      id
      slug
    }
  }
`;

export const EnergySavingPageFragment = gql`
  ${SeoMetaTagsFragment}
  ${ProductHeroFragment}
  ${PageContentFragment}
  fragment EnergySavingPageFragment on EnergySavingPageRecord {
    id
    slug
    name
    seo: _seoMetaTags {
      ...SeoMetaTagsFragment
    }
    __typename
    hero {
      ...ProductHeroFragment
    }
    content {
      id
      anchor
      content {
        ...PageContentFragment
      }
    }
    parentPage: parentSolution {
      id
      slug
    }
  }
`;

export const LongReadPageFragment = gql`
  ${SeoMetaTagsFragment}
  ${PageContentFragment}
  ${ResponsiveImageFragment}
  fragment LongReadPageFragment on LongReadRecord {
    __typename
    id
    title
    slug
    parentPage: product {
      ... on EnergySavingPageRecord {
        id
        slug
        parentPage: parentSolution {
          id
          slug
          parentPage: parentSolution {
            id
            slug
          }
        }
      }
      ... on ProductPageRecord {
        id
        slug
        parentPage: parentSolution {
          id
          slug
          parentPage: parentSolution {
            id
            slug
          }
        }
      }
      ... on FinancingPageRecord {
        id
        slug
        parentPage: parentSolution {
          id
          slug
          parentPage: parentSolution {
            id
            slug
          }
        }
      }
    }
    description
    image {
      id
      url
      responsiveImage(
        imgixParams: { w: 400, h: 400, fit: crop, crop: faces, auto: [compress, format] }
      ) {
        ...ResponsiveImage
      }
    }
    seo: _seoMetaTags {
      ...SeoMetaTagsFragment
    }
    content {
      id
      anchor
      content {
        ...PageContentFragment
      }
    }
  }
`;

export const QuoteSeoPageFragment = gql`
  ${SeoMetaTagsFragment}
  ${CampaignContainerFragment}
  ${ColorFragment}
  ${PageContentFragment}
  fragment QuoteSeoPageFragment on QuoteSeoPageRecord {
    __typename
    id
    title
    slug
    seo: _seoMetaTags {
      ...SeoMetaTagsFragment
    }
    content {
      __typename
      ... on CampaignContainerRecord {
        bgColor {
          ...ColorFragment
        }
        campaignContainerContent {
          ...CampaignContainerFragment
        }
      }
      ... on ProductPageContentRecord {
        bgColor {
          ...ColorFragment
        }
        content {
          ...PageContentFragment
        }
      }
    }
  }
`;

export const LongReadSlugsFragment = gql`
  fragment LongReadSlugsFragment on LongReadRecord {
    id
    slug
    parentPage: product {
      ... on EnergySavingPageRecord {
        id
        slug
      }
      ... on ProductPageRecord {
        id
        slug
      }
      ... on FinancingPageRecord {
        id
        slug
      }
    }
  }
`;

export const ProductPageSlugsFragment = gql`
  fragment ProductPageSlugsFragment on ProductPageRecord {
    id
    slug
    parentPage: parentSolution {
      id
      slug
    }
  }
`;

export const FinancingPageSlugsFragment = gql`
  fragment FinancingPageSlugsFragment on FinancingPageRecord {
    id
    slug
    parentPage: parentSolution {
      id
      slug
    }
  }
`;

export const EnergySavingPageSlugsFragment = gql`
  fragment EnergySavingPageSlugsFragment on EnergySavingPageRecord {
    id
    slug
    parentPage: parentSolution {
      id
      slug
    }
  }
`;
